import { Button, CircularProgress, Typography } from "@mui/material"
import { KaziModal } from "../../../../Shared Components/Kazi/KaziModal"
import { Dispatch, SetStateAction } from "react";
import { useToast } from "../../../../Hooks/useToast";
import { useUser } from "../../../../Hooks/useUser";
import { useDeactivateClientMutation } from "../../../../Redux/api/clientApi";
import { useDeactivateTalentMutation } from "../../../../Redux/api/talentApi";
import { ProfileType } from "../../../../Types/General";
import { KaziButton } from "../../../../Shared Components/Kazi/KaziButton";

interface AccountDeletionModalProps {
    open: boolean;
    setOpen: Dispatch<SetStateAction<boolean>>;
}
export const AccountDeletionModal = ({ open, setOpen}:AccountDeletionModalProps) => {
    /* ******************** Hooks ******************** */
    const { showToast } = useToast();
    const { user, type, locator } = useUser();
    const [ deactivateClient, {isLoading: clientDeactivating} ] = useDeactivateClientMutation();
    const [ deactivateTalent, {isLoading: talentDeactivating} ] = useDeactivateTalentMutation();
    /* ******************** Variables ******************** */
    const isDeactivating = clientDeactivating || talentDeactivating;
    /* ******************** Functions ******************** */
    const handleClose = () => {
        setOpen(false)
    }
    const handleDeleteAccount = () => {
        //TODO: Cancel Membership
        //TODO: Set all notifications to false
        if (type === ProfileType.Client) {
            deactivateClient(locator!)
            .unwrap()
            .then(() => {
                handleClose();
                showToast({
                    text: 'Your account has been deactivated.',
                    variant: 'warning',
                    extended: true
                })
            })
            .catch((err) => {
                console.error("Error occured while deactivating client: ", err)
                showToast({
                    text: 'Unable to Deactivate the Account',
                    variant: 'error'
                })
            })
        }

        if (type === ProfileType.Talent) {
            deactivateTalent(locator!)
            .unwrap()
            .then(() => {
                handleClose();
                showToast({
                    text: 'Your account has been deactivated.',
                    variant: 'warning',
                    extended: true
                })
            })
            .catch((err) => {
                console.error("Error occured while deactivating talent: ", err)
                showToast({
                    text: 'Unable to Deactivate the Account',
                    variant: 'error'
                })
            })

        }
    }
    /* ******************** Effects ******************** */
    /* ******************** JSX ******************** */
    return (
        <>
            <KaziModal 
                open={open}
                handleClose={handleClose}
                title="Are you sure you want to deactivate your account?"
                content={
                    <>
                        <Typography>Once you deactivate your account, your profile will no longer be accessible on our platform. You will no longer have access to the marketplace. </Typography>
                        <Typography> Accounts are permanently deleted 30 days after deactivation, and any data associated with {<strong>{user?.email}</strong>} will be removed and no longer saved.</Typography>
                    </>
                }
                actions={[
                    <Button onClick={handleClose} variant="outlined">Cancel</Button>,
                    <KaziButton 
                        onClick={handleDeleteAccount} 
                        variant="contained"
                        loading={{
                            isLoading: isDeactivating,
                            loadingText: "Deactivating...",
                            color: 'secondary'
                        }}
                        text="Yes, Deactivate"
                    />   
                ]}
            />
        </>
    )
}